module.exports = __webpack_public_path__ + "img/News-Banner.4107f9ce.png";